var _a;
import * as yup from 'yup';
import fieldValidationMessageIds from './validationMessages';
import { createAuthFormHook } from './createAuthFormHook';
export var ERegisterUserDetailsFormField;
(function (ERegisterUserDetailsFormField) {
    ERegisterUserDetailsFormField["USERNAME"] = "username";
    ERegisterUserDetailsFormField["GENDER"] = "gender";
    ERegisterUserDetailsFormField["BIRTH_DATE"] = "birthDate";
    ERegisterUserDetailsFormField["COUNTRY"] = "country";
})(ERegisterUserDetailsFormField || (ERegisterUserDetailsFormField = {}));
var required = fieldValidationMessageIds.required;
export var registerUserDetailsFormSchema = yup.object((_a = {},
    _a[ERegisterUserDetailsFormField.USERNAME] = yup.string().required(required),
    _a[ERegisterUserDetailsFormField.GENDER] = yup
        .mixed()
        .nullable()
        .required(required),
    _a[ERegisterUserDetailsFormField.BIRTH_DATE] = yup
        .date()
        .nullable()
        .required(required),
    _a[ERegisterUserDetailsFormField.COUNTRY] = yup
        .mixed()
        .nullable()
        .required(required),
    _a));
export var useRegisterUserDetailsForm = createAuthFormHook(registerUserDetailsFormSchema);
